import React from 'react';
import './index.scss';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { HttpStatusCode } from '@/fetch/core/constant';
import { message } from 'antd';
import CollectMapApi from '@/fetch/bussiness/collectMap';
import classNames from 'classnames';
import { SystemStateEnum } from '@/utils/constant';
const fetchApi = new CollectMapApi();

const PauseCollectMap = (props: {
  vehicleName: string;
  cockpitNumber: string;
  taskId: number;
  systemState: any;
  onClose: any;
}) => {
  const { login } = useSelector((state: RootState) => state);
  const { cockpitNumber, vehicleName, onClose, taskId } = props;
  const pauseCollectMap = async () => {
    try {
      if (!login.userInfo?.userName || !cockpitNumber || !vehicleName) {
        return;
      }
      const res = await fetchApi.switchCollection({
        cockpitNumber,
        vehicleName,
        taskId,
        action: 0,
      });
      if (res.code === HttpStatusCode.Success) {
        message.success('暂停采集成功');
        onClose && onClose();
      } else {
        message.error(res.message || '网络请求错误');
        return;
      }
    } catch (e) {
      message.error(`${vehicleName}暂停采集失败`);
      return;
    }
  };
  return (
    <>
      <li
        className={classNames('btn-item', {
          'pause-collect-map': props.systemState !== SystemStateEnum.OFFLINE,
          'pause-collect-map-disabled':
            !props.systemState || props.systemState === SystemStateEnum.OFFLINE,
        })}
        onClick={() => {
          if (!props.systemState) {
            message.error('系统离线，无法暂停采集');
            return;
          }
          pauseCollectMap();
        }}
      >
        <i>暂停采集</i>
      </li>
    </>
  );
};

export default React.memo(PauseCollectMap);
